/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * ion-accordion-group, ion-accordion y ion-radio-group emiten "ionValueChange" como evento interno al montarse o
 * cambiar de valor. Ni la app ni @ionic/angular lo escuchan, pero zone.js envolvía los listeners internos de Ionic y
 * cada emisión disparaba un ciclo completo de detección de cambios (300+ al desplegar una tabla con 100 materias,
 * unos 60 ms cada uno). Sin parchear este evento los listeners siguen funcionando, solo que fuera de la zona.
 * Los eventos que sí usa la app (ionChange, ionInput...) siguen parcheados.
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['ionValueChange']
